import { AccessToken } from "@/api/accessDecoder";
import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";

interface IAuthorized {
  access: string;
  refreshToken: string;
  login: string;
}

const state = (): IAuthorized => ({
  access: AccessToken.access,
  refreshToken: AccessToken.refreshToken,
  login: sessionStorage.getItem("login") || "",
});

const getters: _GettersTree<IAuthorized> = {
  getAccess: (state): string => state.access,

  getRefreshToken: (state): string => state.refreshToken,

  isAuthorized: (state): boolean => !!state.refreshToken,

  isExpired: (): boolean => AccessToken.isExpired,

  isValid: (): boolean => AccessToken.isValid,

  permissions: (): string[] => AccessToken.permissions,

  userRole: (): string | null => AccessToken.userRole,

  userId: (): string => AccessToken.id,

  getLogin: (state): string => state.login,
};

interface AuthActions {
  setAccess(access: string): void;
  setRefreshToken(refreshToken: string): void;
  setLogin(login: string): void;
  setTokens(access: string, refreshToken: string): void;
  clearTokens(): void;
  syncFromStorage(): void;
  logout(): void;
}
const actions: AuthActions = {
  setAccess(this: AuthActions & IAuthorized, access: string) {
    this.access = access;
    AccessToken.setAccessToken = access;
  },
  setRefreshToken(this: AuthActions & IAuthorized, refreshToken: string) {
    this.refreshToken = refreshToken;
    AccessToken.setRefreshToken = refreshToken;
  },
  setLogin(this: AuthActions & IAuthorized, login: string) {
    this.login = login;
    sessionStorage.setItem("login", login);
  },
  setTokens(this: AuthActions & IAuthorized, access: string, refreshToken: string) {
    this.access = access;
    this.refreshToken = refreshToken;

    AccessToken.setAccessToken = access;
    AccessToken.setRefreshToken = refreshToken;
  },
  clearTokens(this: AuthActions & IAuthorized) {
    this.access = "";
    this.refreshToken = "";

    AccessToken.deleteAccessToken();
    AccessToken.deleteRefreshToken();
  },
  syncFromStorage(this: AuthActions & IAuthorized) {
    this.access = AccessToken.access;
    this.refreshToken = AccessToken.refreshToken;
  },
  logout(this: AuthActions & IAuthorized) {
    this.clearTokens();
    AccessToken.logout();
  },
};

export const useAuthorizationStore: StoreDefinition<
  string,
  IAuthorized,
  _GettersTree<IAuthorized>,
  _ActionsTree
> = defineStore<string, IAuthorized>("authorization", {
  state,
  getters,
  actions,
});
